import { connect } from 'react-redux';
import { intersection } from 'lodash';
import {
  getActiveFieldId
} from 'current/selectors';
import {
  getCompleteMapLayers,
  getImageSeasonsOfLayerForField,
  getImagesOfLayerForField,
  getUsableOverlayLayerGroups
} from 'imagery/selectors';
import { isResourceTypeLoaded } from 'loading/selectors';
import { getSelectedMapLayer, getCompleteMapYear } from 'manual/selectors';

import { requestCompleteMapLayers, requestCompleteMapsJob } from 'manual/requesters';
import { requestGenerateZoneLayers } from 'imagery/requesters';
import { setSelectedMapLayer } from 'manual';
import {
  seasonlessOverlayLayers,
  datelessOverlayLayers
} from 'constants/imagery';
import {
  allowedZoneGenerationLayers
} from 'constants/scripts';
import { resourceType } from '../constants/loading';
import ZoneGenerationSelection from './ZoneGenerationSelection';

export default connect(
  (state) => {
    const fieldId = getActiveFieldId(state);
    const layerGroups = getUsableOverlayLayerGroups(state)
    .filter(group => intersection(group.layers, allowedZoneGenerationLayers).length > 0);
    
    if(layerGroups.length) {
      layerGroups.forEach(group => {
        group.layers = group.layers.filter(layer => allowedZoneGenerationLayers.includes(layer));
      });
    }

    const selectedMapLayer = getSelectedMapLayer(state);
    const selectedUuid = selectedMapLayer ? selectedMapLayer.selectedMapUuid : null;
    const selectedLayer = selectedMapLayer ? selectedMapLayer.selectedMapType : null;
    const showDates = (layer) => {
      const layerTypeHasDates = !datelessOverlayLayers[layer];
      return (!!layer && layerTypeHasDates);
    };
    const showSeasons = (layer) => {
      const layerTypeHasSeasons = !seasonlessOverlayLayers[layer];
      return (!!layer && layerTypeHasSeasons);
    };
    const getSeasons = (selectedLayer) => {
      return getImageSeasonsOfLayerForField({ state, layer: selectedLayer, fieldId });
    };
    const getImagesForSeason = (selectedLayer, selectedSeason) => {
      return getImagesOfLayerForField({ state, layer: selectedLayer, fieldId, season: selectedSeason });
    };
    const completeMapLayers = getCompleteMapLayers(state) ? getCompleteMapLayers(state) : {};
    const completeMapYear = String(getCompleteMapYear(state));
    
    return {
      areCompleteMapLayersLoaded: isResourceTypeLoaded({
        state,
        type: resourceType.COMPLETE_MAP_LAYERS
      }),
      areMapLayersLoaded: isResourceTypeLoaded({
        state,
        type: resourceType.SELECT_FIELD_MAP_LAYER
      }),
      completeMapYear,
      completeMapLayers,
      fieldId,
      layerGroups,
      getSeasons,
      getImagesForSeason,
      selectedUuid,
      selectedLayer,
      showDates,
      showSeasons
    };
  },
  (dispatch) => {
    return {
      fetchCompleteMapLayers: () => dispatch(requestCompleteMapLayers()),
      fetchZoneLayers: () => dispatch(requestGenerateZoneLayers()),
      requestCompleteMapsJob: (fieldId, year) => dispatch(requestCompleteMapsJob(fieldId, year)),
      setMapLayer: (mapLayer) => dispatch(setSelectedMapLayer(mapLayer))
    };
  }
)(ZoneGenerationSelection);
